<template>
  <div cols="12" class="mb-3" v-if="review != null" no-wrap rounded>
    <div class="d-flex justify-content-between">
      <strong>{{ review.clientName }}</strong>
      <div class="text-muted">
        <small>#{{ review.serviceNumber }}</small>
      </div>
    </div>
    
    <div v-if="false">
      <small class="text-muted font-weight-bold">{{ review.platform }}</small>
    </div>
    
    <md-icon
      v-for="(star, index) in 5"
      v-bind:key="star"
      icon="star"
      :class="getStarColor(review.rate, index)"
      style="font-size: 12px;"/>
    <small class="text-muted ml-2">{{ review.reviewedAt }}</small>
    <md-icon v-if="review.rate <= 2" icon="warning" class="text-danger ml-2"/>

    <div>
      <small v-if="review.review != ''" class="text-justify">{{ review.review }}</small>
      <small v-else class="text-muted">- {{ $t('bookings.withoutCommentsOnReview') }} -</small>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      modelId: {
        type : Number,
        required: true,
        default:-1
      }
    },
    components: {},
    data() {
      return {
        review: null
      }
    },
    methods: {
      getStarColor(stars_round, index) {
        let color = (stars_round >= index + 1) ?'text-warning' : 'text-secondary';
        return 'font-weight-bolder '+color
      },
      getReview() {
        if (this.modelId != -1) {
          this.$root.api.get(`/reviews/service/${this.modelId}`).then( res => {
            this.review  = res.data.body;
          }).catch((err)=>{
            if(err.response.status===404){
              this.$root.$emit("bv::hide::modal",	"modal-reservations-view");
            }
            this.$root.handleRequestError(err)
          });
        }
      }
    },
    mounted() {
      this.getReview()
    },
  } 
</script>
